import React__default from 'react';
import { ModalWrapper, ModalBody, Anchor, ModalFooter, ModalPrimaryButton } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { getUrlLocalised, formatMoney } from '../../../utils/utils.js';
import styles from './FodModal.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const FodModal = (props) => {
    const { site, locale } = useSiteContext();
    const { t } = useTranslation(site.realm);
    const termsLink = getUrlLocalised(t, '/info/legal/terms');
    const closeModal = () => {
        props.setIsOpen(false);
    };
    return (React__default.createElement(ModalWrapper, { closeBtnAriaLabel: "Close", heading: t('checkout.fod-banner.modal.title', { fodDiscount: props.fodPercentage }), headingId: "aus-fod-modal", isOpen: props.isOpen, onClose: closeModal, className: styles.modalWrapper, size: "sm" },
        React__default.createElement(ModalBody, { className: styles.modalBody },
            React__default.createElement("div", { className: styles.benefit }, t('checkout.fod-banner.modal.paragraph-1', {
                fodDiscount: props.fodPercentage,
                capping: formatMoney(props.fodCapping, site.currency, locale),
            })),
            React__default.createElement("div", { className: styles.benefit }, t('checkout.fod-banner.modal.paragraph-2')),
            React__default.createElement("div", { className: styles.benefit }, t('checkout.fod-banner.modal.paragraph-3')),
            React__default.createElement("div", { className: styles.benefit },
                React__default.createElement(Anchor, { className: styles.link, href: getUrlLocalised(t, termsLink), isBold: true, target: "Terms and conditions link" }, t('checkout.fod-banner.modal.paragraph-4')))),
        React__default.createElement(ModalFooter, { className: styles.footer },
            React__default.createElement(ModalPrimaryButton, { length: "full", onClick: closeModal }, t('checkout.common.close')))));
};

export { FodModal };
//# sourceMappingURL=FodModal.js.map
